import { render } from "./FiscalPeriods.vue?vue&type=template&id=7f478217&ts=true"
import script from "./FiscalPeriods.vue?vue&type=script&lang=ts"
export * from "./FiscalPeriods.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__